import React from 'react'
import UrgencyLabel from 'components/Luxkit/Label/UrgencyLabel'
import cn from 'clsx'
import useHasMounted from 'hooks/useHasMounted'
import { pluralizeToString } from 'lib/string/pluralize'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
interface Props {
  availableRoomCount: number;
}

function OfferUrgencyRoomCount(props: Props) {
  const {
    availableRoomCount,
  } = props

  const hasMounted = useHasMounted()

  const croPopularOptionBookingRemaining = !!useOptimizelyExperiment(OptimizelyExperiments.croPopularOptionBookingRemaining)
  if (!croPopularOptionBookingRemaining) {
    return null
  }

  return <UrgencyLabel
    className={cn({ 'not-mounted': !hasMounted })}
    variant="critical2"
  >
    Guest favourite – {pluralizeToString('room', availableRoomCount)} left
  </UrgencyLabel>
}

export default OfferUrgencyRoomCount
